/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Case_Field_MakeInputs */

const en_case_field_make = /** @type {(inputs: Case_Field_MakeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Make`)
};

const pt_br2_case_field_make = /** @type {(inputs: Case_Field_MakeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Marca`)
};

/**
* | output |
* | --- |
* | "Make" |
*
* @param {Case_Field_MakeInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const case_field_make = /** @type {((inputs?: Case_Field_MakeInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_Field_MakeInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_case_field_make(inputs)
	return pt_br2_case_field_make(inputs)
});